import { ReactNode } from "react";
import classNames from "classnames";
import "./index.scss";

interface IProps {
  label: ReactNode;
  onClick?: () => void;
  variant:
    | "h1Bold"
    | "h1Med"
    | "h2Bold"
    | "h2Med"
    | "h3Bold"
    | "h3Med"
    | "h4Med"
    | "h4Bold"
    | "h5Bold"
    | "h5Med"
    | "h6Bold"
    | "h6Medium"
    | "h6Underline"
    | "h6Book"
    | "h7Med"
    | "h7Bold"
    | "h7Book"
    | "h7Underline"
    | "h7Light"
    | "h8Bold"
    | "h8Book"
    | "h8MedItalic"
    | "h8Italic"
    | "h8Med"
    | "h8Underline"
    | "h9Bold"
    | "h9Medium"
    | "h9Book"
    | "h10Bold"
    | "h10Medium"
    | "h10Book";

  styles?: string;
  spanLabel?: string;
  spanStyle?: string;
  link?: string;
}

interface ITypography {
  [key: string]: string | any;
}

const variantsMapping: ITypography = {
  h1Bold: "h1",
  h1Med: "h1",
  h2Bold: "h2",
  h2Med: "h2",
  h3Bold: "h3",
  h3Med: "h3",
  h4Med: "h4",
  h4Bold: "h4",
  h5Bold: "h5",
  h5Med: "h5",
  h6Bold: "h6",
  h6Medium: "h6",
  h6Underline: "h6",
  h6Book: "h6",
  h7Med: "h6",
  h7Bold: "h6",
  h7Book: "h6",
  h7Underline: "h6",
  h7Light: "h6",
  h8Bold: "h6",
  h8Book: "h6",
  h8MedItalic: "h6",
  h8Italic: "h6",
  h8Med: "h6",
  h8Underline: "h6",
  h9Bold: "h6",
  h9Book: "h6",
  h9Medium: "h6",
  h10Bold: "h6",
  h10Book: "h6",
  h10Medium: "h6",
};

export const Typography = ({
  label,
  variant,
  styles,
  onClick,
}: IProps) => {
  const Component = variantsMapping[variant];

  return (
    <Component
      className={classNames(`${variant}`, { [`${styles}`]: styles })}
      onClick={onClick}
    >
      {label}
    </Component>
  );
};
